import React from 'react';

// Components
import Download from 'components/download';
import constants from '../constants';

// Images
import retinaImage from 'images/retina/retina-demo.jpg';


const RetinaDescriptionPage = () => (
  <div className="container">
    <div className="l-demo-content">
      <div className="tab-content-description">
        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <div className="summary">
              <p>In many cities the population is exposed to elevated levels of air pollution. Often the local air quality is not well known due to the sparseness of the official monitoring network, or unrealistic assumptions being made in urban air quality models (such as vehicle emission factors).
                New trends in air quality monitoring ask for smart systems to make optimal use of the heterogeneous data sources. The RETINA system smartly interpolates measurements to locations where air quality is not directly measured.</p>
            </div>
          </div>
          <div className="col-md-10">
            <div className="summary">
              <p>Applied to the observations of the official network it produces high spatio-temporal resolution maps of pollution concentrations. RETINA also offers the possibility to assimilate sensor measurements of lesser accuracy for an improved description of local air quality.</p>
            </div>
            <div className="summary">
              Localized air quality data are created shortly after the measurements become available. When combined with meteorological forecasts, RETINA produces detailed urban air quality forecasts.
            </div>
          </div>
          <div className="col-md-10">
            <div className="demo-image">
              <img src={retinaImage} alt="retina demo" />
            </div>
          </div>
          <div className="col-md-12">
            <div className="characteristics-table">
              <div className="col-md-12">
                <div className="main-characteristics">
                  Main characteristics
                    </div>
              </div>
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Air pollutants
                            </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          NO2, particulate matter, in units µg/m³.
                            </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Spatial Resolution
                            </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          Street-level (about 50m)
                            </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Temporal Range
                            </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          Now-casting, historic data, 48h forecasting.
                            </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Temporal Resolution
                            </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          Hourly.
                            </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Update frequency
                            </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          Hourly.
                            </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-item">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="table-label">
                          Domain size
                            </div>
                      </div>
                      <div className="col-md-8">
                        <div className="table-value">
                          Urban areas covering around 25x25 km².
                            </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Download pdf={constants.retina.factsheet} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default RetinaDescriptionPage;



// WEBPACK FOOTER //
// ./src/pages/products/retina/description.js